import { FieldMatchNode, QueryParameters } from './types.js'

export function isRangeTerm(fieldMatch: FieldMatchNode, parameters: QueryParameters): boolean {
  return 'term_min' in fieldMatch || 'term_max' in fieldMatch
}

export function isWildcardMatch(fieldMatch: FieldMatchNode, parameters: QueryParameters): boolean {
  const term = parameters[fieldMatch.term.id]

  if (Array.isArray(term)) {
    return term.some(t => typeof t === 'string' && (t.endsWith('*') || t.startsWith('*')))
  }

  return typeof term === 'string' && (term.endsWith('*') || term.startsWith('*'))
}

export function isToBeComparedLiterally(fieldMatch: FieldMatchNode, parameters: QueryParameters): boolean {
  return fieldMatch.termQuotes !== 'none'
}

export function matchesAnyTruthyValue(fieldMatch: FieldMatchNode, parameters: QueryParameters): boolean {
  if ('term' in fieldMatch) {
    const term = parameters[fieldMatch.term.id]

    if (term === '*') {
      return true
    }
  } else if ('term_min' in fieldMatch && 'term_max' in fieldMatch) {
    const min = parameters[fieldMatch.term_min?.id]
    const max = parameters[fieldMatch.term_max?.id]

    if (min === '*' && max === '*') {
      return true
    }
  }
  
  return false
}

export function comparesToBoolean(fieldMatch: FieldMatchNode, parameters: QueryParameters): boolean {
  const term = parameters[fieldMatch.term.id]

  if (Array.isArray(term)) {
    return term.every(t => {
      if (typeof t === 'boolean') return true
      if (typeof t !== 'string') return false
      const lowerCaseTerm = t.toLowerCase()
      return lowerCaseTerm === 'true' || lowerCaseTerm === 'false'
    })
  }

  if (typeof term === 'boolean') {
    return true
  }

  if (typeof term !== 'string') {
    return false
  }

  const lowerCaseTerm = term.toLowerCase()
  return lowerCaseTerm === 'true' || lowerCaseTerm === 'false'
}

// function quotedTerm(termString: string) {
//   // tslint:disable-next-line quotemark
//   const escaped = termString.replace(/'/g, "\\'") 
//   return `'${escaped}'`
// }
